import { Skeleton, SweepBar } from "../components/Skeleton"

// Full-page loading state — a silver shimmer skeleton with a sweeping top bar,
// instead of a spinning icon. Reused across the app wherever a page is loading.
const LoadingSpinner = ({ message }) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Silver bar sweeping left -> right */}
      <SweepBar />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        {/* Hero / header block */}
        <Skeleton className="h-56 w-full rounded-2xl" />
        <div className="space-y-3">
          <Skeleton className="h-8 w-2/3" />
          <Skeleton className="h-4 w-1/3" />
        </div>
        {/* Content cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="bg-white dark:bg-gray-800 rounded-xl shadow p-6 space-y-3">
              <Skeleton className="h-10 w-10 rounded-lg" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/2" />
            </div>
          ))}
        </div>
        {message && (
          <p className="text-center text-sm text-gray-400 dark:text-gray-500">{message}</p>
        )}
      </div>
    </div>
  )
}

export default LoadingSpinner
